<template lang="pug">
redesign-dialog(
  v-model="showDialog"
  @close="$emit('close')"
)
  template(#default)
    .image-dialog
      .image-dialog__header
        app-button(
          color="redesignBlack"
          icon
          @click="$emit('close')"
        )
          v-icon $iclose
      template(v-if="showImageDialog")
        v-img(
          :src="images[activeSlide].url"
          :alt="images[activeSlide].description"
          :lazy-src="constants.PlaceholderImage"
        ).image-dialog__img.rounded-32
      template(v-else-if="showImageSliderDialog")
        image-carousel(
          v-model="inputValue"
          height="100%"
          :images="images"
        )
</template>

<script>
import RedesignDialog from '@/components/user-redesign/dialogs/RedesignDialog.vue';
import ImageCarousel from './ImageCarousel.vue';
import PlaceholderImage from '@/assets/placeholder.jpg';

export default {
  name: 'ImageDialog',
  components: {
    RedesignDialog,
    ImageCarousel,
  },
  props: {
    // current slide index
    value: {
      type: Number,
      default: 0,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      required: true,
    },
    showImageDialog: {
      type: Boolean,
      default: false,
    },
    showImageSliderDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSlide: 0,
    };
  },
  computed: {
    constants() {
      return {
        PlaceholderImage,
      };
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.image-dialog {
  position: relative;
  max-height: 80vh;

  &__header {
    position: absolute;
    top: -48px;
    left: 0;
    z-index: 10;
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  &__img {
    max-height: 80vh;
  }
}
</style>
